/*
 * =============================================================================
 * Project: boilerplate
 * Created Date: 2018-03-12, 09:02:23
 * Author: Przemysław Drzewicki <przemyslaw.drzewicki@telestrada.pl>
 * =============================================================================
 * Last Modified: 2018-04-16, 13:25:10
 * Modified By: Przemysław Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada S.A
 * =============================================================================
 */
import React from 'react';
import PropTypes from 'prop-types';
import Brand from "components/layout/brand";
import Login from "components/authorization/login";

import logo from "images/logo.png";

const Authorization = props => 
  (
    <div className="text-center">
      <br/><br/>
      <img className="logo logo--authorization"
        src={logo}
        alt="" />
      <br/><br/>
      <Login redirect={props.router}/>
      <Brand />
    </div>
  )

Authorization.propTypes = {
  router: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
}

export default Authorization;



// WEBPACK FOOTER //
// ./src/rcapp/routes/authorization/index.js